import { auth } from './auth.query';
import { bloodReport } from './blood-report';
import { cwf } from './cwf.query';
import { patient } from './patient.query';
import { study } from './study.query';

export const api = { auth, bloodReport, cwf, patient, study };
